import { render, staticRenderFns } from "./AcademicProgressMonitoring2.vue?vue&type=template&id=d4aa546e&scoped=true"
import script from "./AcademicProgressMonitoring2.vue?vue&type=script&lang=js"
export * from "./AcademicProgressMonitoring2.vue?vue&type=script&lang=js"
import style0 from "./AcademicProgressMonitoring2.vue?vue&type=style&index=0&id=d4aa546e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4aa546e",
  null
  
)

export default component.exports